export default __webpack_public_path__ + "static/media/compact-icon.7a94a5e7.svg";